/** Format a Date as a datetime-local input value ("YYYY-MM-DDTHH:mm") in the BROWSER's tz. */
export function toLocalInputValue(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export interface ExifTimeParts {
  /** Raw EXIF DateTimeOriginal, e.g. "2026:06:01 13:42:05". */
  dateTimeOriginal?: string;
  /** Raw EXIF OffsetTimeOriginal, e.g. "+02:00" or "-05:00". */
  offset?: string;
}

/**
 * 2-step resolution (GPS-timezone step intentionally dropped — see spec):
 *  1. EXIF offset present  -> exact instant, shown in browser-local input value.
 *  2. no offset            -> treat EXIF wall-clock as browser-local directly.
 * Returns a datetime-local string, or null when there is no EXIF time
 * (caller should default to "now").
 */
export function resolveCaughtAtInput(parts: ExifTimeParts): string | null {
  const raw = parts.dateTimeOriginal;
  if (!raw) return null;

  // EXIF date format "YYYY:MM:DD HH:MM:SS" -> ISO-ish "YYYY-MM-DDTHH:MM:SS"
  const m = raw.match(/^(\d{4}):(\d{2}):(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/);
  if (!m) return null;
  const [, yr, mo, day, hh, mm, ss] = m;
  const local = `${yr}-${mo}-${day}T${hh}:${mm}`;

  if (parts.offset && /^[+-]\d{2}:\d{2}$/.test(parts.offset)) {
    const instant = new Date(`${yr}-${mo}-${day}T${hh}:${mm}:${ss}${parts.offset}`);
    if (!isNaN(instant.getTime())) return toLocalInputValue(instant);
  }
  // Step 2: no usable offset — wall-clock is treated as browser-local.
  return local;
}
